// extracted by mini-css-extract-plugin
export default {"Status_wrapper":"cancelorder_Status_wrapper__MWS3h","completed":"cancelorder_completed__Kph2H","pending":"cancelorder_pending__s9x5+","rejected":"cancelorder_rejected__Al0tK"};